<template>
    <div class="card card-basic card--blue card--activated h-auto">
        <div class="card__text">
            <ul class="update-item__wrapper list-unstyled">
                <update-Item
                    v-for="(updateItem, index) in updates"
                    :key="index"
                    :update-item="updateItem"
                />
            </ul>
        </div>
        <div class="card__bottom">
            <div class="card__bottom__button">
                <a :href="link">
                    <span class="card__bottom__button__content">
                        {{ linkText }}
                        <span
                            class="icon-angle-right card__bottom__button__content__icon"
                        >
                        </span>
                    </span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import Axios from 'axios';
import updateItem from '@/components/updates/update-item';
export default {
    components: {
        updateItem
    },
    props: {
        link: {
            type: String,
            default: ''
        },
        linkText: {
            type: String,
            default: ''
        },
        endpoint: {
            type: String,
            default: '/api/v1/domainapi/MyLatestUpdates'
        },
        hideIfEmpty: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            updates: {}
        };
    },

    created() {
        this.getUpdates();
    },

    methods: {
        getUpdates() {
            let url = this.endpoint;
            if (!this.$options.propsData.endpoint) {
                url +=
                    '?contentid=' +
                    document
                        .getElementsByTagName('body')[0]
                        .getAttribute('data-root-page');
            }

            Axios({
                method: 'get',
                url: url
            })
                .then(response => {
                    if (!response.data === null) {
                        return false;
                    }

                    this.updates = response.data;
                    if (this.hideIfEmpty && response.data.length == 0) {
                        this.$parent.hideBlock();
                    }
                    return true;
                })
                .catch(() => false);
        }
    }
};
</script>

<style lang="scss" scoped>
.card__bottom__button a {
    color: $brand-gray;
}
</style>
